<template>
    <div class="last-errors">
        <job-errors :job-class="jobClass" v-if="jobClass" @modalClosed="modalClosed"></job-errors>
        <h5>Last errors</h5>
        <table class="table table-striped">
            <thead>
                <tr>
                    <th>Job Name</th>
                    <th>Error number</th>
                    <th>Last error time</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in tableData">
                    <td>{{item.class_name}}</td>
                    <td>{{item.error_number}}</td>
                    <td>{{formatDate(item.last_time)}}</td>
                    <td>
                        <button class="btn btn-outline-info btn-sm" @click="view(item.class_name)">
                            VIEW ALL
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import jobErrors from './JobErrorsPopUp';
    import moment from 'moment';
    export default {
        name: 'lastErrors',
        data(){
            return {
                tableData: [],
                jobClass: null
            }
        },
        components: { jobErrors },
        methods: {
            getLastErrors() {
                this.$statsService.getLastErrorsGrouped().then( (data) => {
                    this.tableData = data.body;
                });
            },
            archiveText(text) {
                let limit = 50
                return text.length > limit + 3 ? text.substring(0, limit) + '...' : text;
            },
            view(className) {
                this.jobClass = className;
            },
            modalClosed(){
                this.jobClass = null;
            },
            formatDate(time) {
                return moment(time).format('YYYY-MM-DD HH:mm');
            },
        },
        mounted() {
            this.getLastErrors();
        }
    }
</script>
<style lang="scss" scoped>
    .last-errors {
        padding: 15px;
        border: 1px #ddd solid;
        .table {
            th {
                font-size: 13px;
            }
            td {
                font-size: 12px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/stats/tables/lastErrors.table.vue